module.exports = __webpack_public_path__ + "static/media/apple-app-store.2928664f.svg";